<mat-dialog-content class="mat-typography">
  <div class="payment-content">
    <div class="icon">
      <mat-icon class="error-color">close</mat-icon>
    </div>
    <div class="payment-title">{{ 'Payment.Canceled' | translate }}</div>
    <div class="message">
      <div class="">
        {{ 'Payment.CancelMessage' | translate }}
      </div>
      <div class="">
        {{ 'Payment.CancelPostMessage' | translate }}
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>
    {{ 'Buttons.Close' | translate }}
  </button>
</mat-dialog-actions>
